import { Injectable, inject, signal } from '@angular/core';
import { Airport, Airports } from 'src/app/flight/models/Airport';
import { PasseLivreService } from '../passe-livre/passe-livre.service';

/**
 * Read-only cache of the existing `getAirportsBr()` catalog, used for presentation only
 * (city names, destination country). Loaded once per session on demand.
 */
@Injectable({ providedIn: 'root' })
export class AirportCatalogService {
  private readonly passeLivreService = inject(PasseLivreService);
  private readonly airports = signal<ReadonlyMap<string, Airport>>(new Map());
  private requested = false;

  load(): void {
    if (this.requested) return;
    this.requested = true;

    this.passeLivreService.getAirportsBr().subscribe({
      next: (response: Airports) => {
        const byIata = new Map<string, Airport>();
        for (const airport of response?.airport ?? []) {
          const code = normalizeIata(airport?.airportInfo?.iataCode);
          if (code) byIata.set(code, airport);
        }
        this.airports.set(byIata);
      },
      error: () => {
        this.requested = false;
      }
    });
  }

  find(iata: string | null | undefined): Airport | undefined {
    const code = normalizeIata(iata);
    return code ? this.airports().get(code) : undefined;
  }

  cityName(iata: string | null | undefined): string | null {
    return this.find(iata)?.city?.name?.trim() || null;
  }
}

export function normalizeIata(value: string | null | undefined): string | null {
  const code = value?.trim().toUpperCase();
  return code && /^[A-Z]{3}$/.test(code) ? code : null;
}
